import api from "../api";

export const listWorkspace = async (id) => {
  return api.get("/v0/workspace/" + id)
    .then((response) => response.data.data);
}

export const listWorkspaces = async () => {
  return api.get("/v0/workspace")
    .then((response) => response.data.data);
}

export const createWorkspace = async (payload) => {
  return api
    .post("/v0/workspace", payload)
    .then((response) => response.data);
};

export const editWorkspace = async (id, payload) => {
  return api
    .put("/v0/workspace/" + id, payload)
    .then((response) => response.data);
};

export const deleteWorkspace = async (id) => {
  return api
    .delete("/v0/workspace/" + id)
    .then(({ data }) => data);
};
